var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.5V13.5C15.5 13.2348 15.3946 12.9805 15.2071 12.7929C15.0196 12.6054 14.7652 12.5 14.5 12.5H10.5C10.2348 12.5 9.98043 12.6054 9.79289 12.7929C9.60536 12.9805 9.5 13.2348 9.5 13.5V21.5M3.5 10.5C3.49993 10.2091 3.56333 9.92165 3.68579 9.65775C3.80824 9.39384 3.9868 9.15983 4.209 8.97203L11.209 2.97303C11.57 2.66794 12.0274 2.50055 12.5 2.50055C12.9726 2.50055 13.43 2.66794 13.791 2.97303L20.791 8.97203C21.0132 9.15983 21.1918 9.39384 21.3142 9.65775C21.4367 9.92165 21.5001 10.2091 21.5 10.5V19.5C21.5 20.0305 21.2893 20.5392 20.9142 20.9142C20.5391 21.2893 20.0304 21.5 19.5 21.5H5.5C4.96957 21.5 4.46086 21.2893 4.08579 20.9142C3.71071 20.5392 3.5 20.0305 3.5 19.5V10.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDark);
export default __webpack_public_path__ + "static/media/home-dark.298159d07bb58f1d059cad603ada04df.svg";
export { ForwardRef as ReactComponent };